import AwardPageAdmin from './AwardPageAdmin';
export default AwardPageAdmin;
